export default __webpack_public_path__ + "static/media/img_ibm_cloud-colorBkg.9913a004.png";